import { styled } from '@mui/material/styles';
import { Link } from 'gatsby';

export const LinkClearStyles = styled(Link)`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  font-size: ${({ theme }) => theme.typography.fontSize};
  text-decoration: none;
  color: ${({ theme }) => theme.palette.common.black};
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.common.black};
  }
`;
export const LinkAnyClearStyles = styled('a')`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  font-size: ${({ theme }) => theme.typography.fontSize};
  text-decoration: none;
  color: ${({ theme }) => theme.palette.common.black};
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.common.black};
  }
`;
